/**
 * Denis Callinan
 * Project Andromeda
 * August 1st, 2020
 * App.js - Pulling it all together
 */

import React from 'react';

// Components
import SectionHeader from '../components/SectionHeader/SectionHeader.js';
import ClassBox from '../components/ClassBox/ClassBox.js';

// Info
import edu from '../info/edu.json';

export default class Education extends React.Component {
    render() {
        var boxes = edu.map(element => {
            return <ClassBox 
                width = {this.props.state.windowWidth}
                name = {element["name"]}
                special = {element["special"]}
                duration = {element["duration"]}
                location = {element["location"]}
                image = {element["logo"]}
                comp = {element["comp"]}
            />
        })
        return(
            <div className = "page" id = "page-B">
                <SectionHeader sectionID = "education-break" title = "EDUCATION" />
                {boxes}
            </div>
        );
    }
}